import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { BotChatCard } from '@/shared/components';
import { OrderSummaryPayload } from '../../interfaces';
import { BotChatCardType } from '@/shared/enums/botChatCardType.enum';

@Component({
  selector: 'bevvi-order-summary-payload',
  imports: [BotChatCard],
  templateUrl: './order-summary-payload.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSummaryPayloadComponent {
  public readonly payload = input.required<OrderSummaryPayload>();
  public readonly disabled = input(false);

  public readonly userReply = output<string>();

  protected readonly type = BotChatCardType;

  public onPrimaryClick(): void {
    const label = this.payload().primaryAction?.label ?? 'Confirm';
    this.userReply.emit(label);
  }

  public onSecondaryClick(): void {
    const label = this.payload().secondaryAction?.label ?? 'Cancel';
    this.userReply.emit(label);
  }
}
